import { userSetEditMode } from "../../../../actions/user-actions"

import buildViewFormActionButtonsWidgetContainer from "../../../common/build-view-form-action-buttons-widget-container"

export default buildViewFormActionButtonsWidgetContainer(
    userSetEditMode,
    "users",
    true
)
